import * as React from 'react';
import ChevronUpOutlined from './chevron-up-outlined';
import ChevronUpFilled from './chevron-up-filled';
import type { IconCombinedProps } from './types';
const ChevronUpCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ChevronUpFilled ref={ref} {...rest} />;
  }
  return <ChevronUpOutlined ref={ref} {...rest} />;
});
export default ChevronUpCombined;